export default "__VITE_ASSET__DJZTBClI__"